import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { demoLoginKeys } from "@/lib/query";

// Demo logins shown on the sign-in screen. The server returns an empty list in
// production, so the buttons never render and credentials never reach the
// browser there.

const demoAccountSchema = z.object({
  label: z.string(),
  email: z.string(),
  password: z.string(),
});

const demoLoginsResponseSchema = z.object({
  accounts: z.array(demoAccountSchema),
});

export type DemoAccount = z.infer<typeof demoAccountSchema>;

async function fetchDemoLogins(): Promise<DemoAccount[]> {
  const res = await fetch("/api/demo-logins");
  if (!res.ok) return [];
  const parsed = demoLoginsResponseSchema.safeParse(await res.json());
  return parsed.success ? parsed.data.accounts : [];
}

/** Demo accounts available on the sign-in screen. Empty in production. */
export function useDemoLogins() {
  return useQuery({
    queryKey: demoLoginKeys.all,
    queryFn: fetchDemoLogins,
    staleTime: Number.POSITIVE_INFINITY,
  });
}
